import { useCallback } from "react";
import { Pack } from "../Types";
import { EditableText } from "./EditableText";

export const EditableTextMulti = (props: {
  values: string[];
  write: (values: string[]) => void;
  placeholder?: string;
}) => {
  const { values, write, placeholder } = props;

  const updateValue = (index: number) => (value: string) => {
    const newValues = [...values];
    newValues[index] = value;
    write(newValues);
  };

  const updateEvent =
    (index: number) => (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      updateValue(index)(e.target.value);
    };

  return (
    <>
      <div style={{ flex: 1, flexDirection: "column", display: "flex" }}>
        {values.map((value, index) => (
          <textarea
            key={index}
            value={values[index]}
            className="description"
            onChange={updateEvent(index)}
            placeholder={placeholder}
          >
          </textarea>
        ))}
      </div>
      {/* button */}
      <div className="row">
        <button
          className="btn small"
          onClick={() => {
            write([...values, ""]);
          }}
        >
          + add blurb
        </button>
        <button
          className="btn small"
          onClick={() => {
            write(values.slice(0, values.length - 1));
          }}
        >
          - remove blurb
        </button>
      </div>
    </>
  );
};
